import { render, staticRenderFns } from "./ShowPixReceipt.vue?vue&type=template&id=530c61b8&scoped=true&"
import script from "./ShowPixReceipt.vue?vue&type=script&lang=js&"
export * from "./ShowPixReceipt.vue?vue&type=script&lang=js&"
import style0 from "./ShowPixReceipt.vue?vue&type=style&index=0&id=530c61b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530c61b8",
  null
  
)

export default component.exports